import { $FixMe } from '@eventbrite/ts-utils';
import loadable from '@loadable/component';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { constructSearchUrl } from '../../../../redux/selectors/url';
import { DiscoverState, PaginationData } from '../../../../types';
import { handleGetPage as handleGetPageAction } from './actions/pagination';
import { SearchFooter } from './components';

const SearchFooterLegacy = loadable(() => import('./components'), {
    resolveComponent: (components: any) => components.SearchFooterLegacy,
});

export type SearchFooterProps = {
    pagination: PaginationData;
};

export type SearchFooterReduxProps = {
    isBotRequest: boolean;
    prevPageUrl: string;
    nextPageUrl: string;
    firstPageUrl: string;
    lastPageUrl: string;
    handleGetPage: Function;
};

const SearchFooterWrapper = (
    props: SearchFooterProps & SearchFooterReduxProps,
) => {
    const { isBotRequest, pagination } = props;
    const paginationData = getPaginationData(pagination);

    return isBotRequest ? (
        <SearchFooterLegacy {...props} {...paginationData} />
    ) : (
        <SearchFooter {...props} {...paginationData} />
    );
};

function getPaginationData(pagination: PaginationData) {
    return {
        hasEventResults: pagination.objectCount > 0,
        totalNumResults: pagination.objectCount,
        currentPage: pagination.page,
        pageCount: pagination.pageCount,
        isNextDisabled: pagination.page === pagination.pageCount,
    };
}

const _mapStateToProps = (
    state: DiscoverState,
    ownProps: SearchFooterProps & RouteComponentProps,
) => {
    return {
        isBotRequest: state.app.isBotRequest,
        prevPageUrl: constructSearchUrl(
            ownProps.pagination.page - 1,
            state.search.eventSearch,
            state.location.slug,
            ownProps.history.location,
        ),
        nextPageUrl: constructSearchUrl(
            ownProps.pagination.page + 1,
            state.search.eventSearch,
            state.location.slug,
            ownProps.history.location,
        ),
        firstPageUrl: constructSearchUrl(
            0,
            state.search.eventSearch,
            state.location.slug,
            ownProps.history.location,
        ),
        lastPageUrl: constructSearchUrl(
            ownProps.pagination.pageCount - 1,
            state.search.eventSearch,
            state.location.slug,
            ownProps.history.location,
        ),
    };
};

const _mapDispatchToProps = {
    handleGetPage: handleGetPageAction,
};

export const SearchFooterContainer: FunctionComponent<SearchFooterProps> =
    compose<$FixMe>(
        withRouter,
        connect(_mapStateToProps, _mapDispatchToProps),
    )(SearchFooterWrapper);
